/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_RetryInputs */

const en_lesson_retry = /** @type {(inputs: Lesson_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const he_lesson_retry = /** @type {(inputs: Lesson_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נסה שוב`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Lesson_RetryInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_retry = /** @type {((inputs?: Lesson_RetryInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_RetryInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_retry(inputs)
	return he_lesson_retry(inputs)
});